import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { IonButton, IonCol, IonRow } from '@ionic/angular/standalone';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormSelectComponent } from '../shared/form/components/form-select/form-select.component';
import { FormTextFieldComponent } from '../shared/form/components/form-text-field/form-text-field.component';
import { ShipperConfigPopupComponent } from './shipper-config-popup/shipper-config-popup.component';

@NgModule({
  declarations: [ShipperConfigPopupComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSortModule,
    MatTableModule,
    MatCheckboxModule,
    MatIconModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    NgSelectModule,
    IonRow,
    IonCol,
    IonButton,
    FormTextFieldComponent,
    FormSelectComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ShipperConfigModule {}
